import type { AnimationMode, Theme } from "./types";

export type InviteStage = "draft" | "created" | "sent" | "opened" | "responded";

export type ResponseStatus = "yes" | "no";

export type InviteKind = "draft" | "published";

export interface InviteMedia {
  kind: "image" | "video" | "mixed" | "audio";
  label: string;
  detail: string;
}

export interface BaseInvite {
  id: string;
  title: string;
  recipientName: string;
  theme: Theme;
  animationMode: AnimationMode;
  media: InviteMedia;
  createdAt: string;
  expiresAt?: string;
  premium: boolean;
}

export interface DraftInvite extends BaseInvite {
  kind: "draft";
  status: "draft";
}

export interface PublishedInvite extends BaseInvite {
  kind: "published";
  status: Exclude<InviteStage, "draft">;
  slug: string;
  publicUrl: string;
  responseStatus?: ResponseStatus;
  responseAt?: string;
  responseLabel?: string;
}

export type MyInvite = DraftInvite | PublishedInvite;

export const INVITE_STAGE_ORDER: InviteStage[] = [
  "draft",
  "created",
  "sent",
  "opened",
  "responded"
];

export const INVITE_STAGE_LABELS: Record<InviteStage, string> = {
  draft: "Drafts",
  created: "Created",
  sent: "Sent",
  opened: "Opened",
  responded: "Responded"
};

export const THEME_LABELS: Record<Theme, string> = {
  apologyLetter: "Apology Letter",
  classic: "Classic",
  festive: "Festive",
  elegant: "Elegant",
  minimal: "Minimal",
  romantic: "Romantic",
  velvet: "Velvet",
  playful: "Playful",
  cosmic: "Cosmic",
  luxuryDark: "Luxury dark",
  cinematic: "Cinematic",
  funnyChaos: "Funny chaos"
};

export const ANIMATION_LABELS: Record<AnimationMode, string> = {
  escapeNo: "Escaping No",
  growYes: "Grow Yes",
  shakeNo: "Shake No",
  swapButtons: "Swap buttons",
  lockedNo: "Locked No",
  countdownReveal: "Countdown reveal",
  confettiYes: "Confetti Yes",
  typewriterReveal: "Typewriter reveal",
  envelopeReveal: "Envelope reveal",
  dramaticReveal: "Dramatic reveal"
};
